import React, {Component} from "react";
import {AutoComplete, Input} from "antd";
import {SymbolProps} from "../model/symbol";
import AxiosUtil from "../../../utils/AxiosUtil";


interface IProps {
    searchCallback: (code: string) => void
}

export default class TaskList extends Component<IProps> {

    state = {
        loading: false,
        symbolData: [] as SymbolProps[],
        options: [],
    }

    componentDidMount() {
        this.loadSymbolData();
    }
    render() {

        const onSelect = (value: string, option: any) => {
            console.log('onSelect', value, option);
            this.props.searchCallback(option.code);
        };

        const onSearch = (value: string) => {
            console.log('onSearch', value);

            if (!value || value === '') {
                this.setState({options: []});
            } else {
                const opt: any[] = [];
                for (let i = 0; i < this.state.symbolData.length; i++) {
                    const rec = this.state.symbolData[i];
                    if (rec.symbol.indexOf(value) >= 0 ||
                        rec.symbol_name.indexOf(value) >= 0 ||
                        rec.security_spell.indexOf(value.toUpperCase()) >= 0) {
                        opt.push({
                            code: rec.symbol,
                            value: rec.symbol + ' ' + rec.symbol_name,
                            label: rec.symbol + ' ' + rec.symbol_name,
                        })
                    }
                    if (opt.length >= 12) {
                        break;
                    }
                }
                this.setState({options: opt});
            }
        };

        return (
            <div className={"search-bar"}>
                <AutoComplete style={{width: '100%'}}
                              options={this.state.options}
                              onSelect={onSelect}
                              onSearch={onSearch}
                >
                    <Input.Search placeholder="请输入 股票代码 / 股票名称 / 拼音缩写 查找相关研报" enterButton
                                  allowClear={true}/>
                </AutoComplete>
            </div>
        );
    }

    loadSymbolData = () => {
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({symbolData: dat.list});
            }
        }
        AxiosUtil.AxiosRequest('/api/yb/getSymbol', {}, callback);
    }
}